import React, { useEffect, useState } from "react";
import "./verification.scss";
import {
  Box,
  Container,
  Grid,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import brandStore from "../../store/brandStore";
import authStore from "../../store/authStore";
import { LoadingButton } from "@mui/lab";
import { Link, useNavigate } from "react-router-dom";
import snackbarStore from "../../store/snackbarStore";
import { BRAND_NAME_LOGO } from "../../constant";

const Verification = () => {
  const isNonMobile = useMediaQuery("(min-width: 600px)");
  const navigate = useNavigate();
  const BrandStore = brandStore();
  const AuthStore = authStore();
  const SnackbarStore = snackbarStore();

  const [isLoading, setIsLoading] = useState();
  const [inputOTP, setInputOTP] = useState("");

  useEffect(() => {
    window.scrollTo({ top: 0 });
    if (AuthStore.OTP === null) {
      navigate("/");
    }
  }, []);

  const verifyOTP = async () => {
    if (AuthStore.OTP === parseInt(inputOTP)) {
      setIsLoading(true);
      const res = await AuthStore.signIn();
      if (res) {
        // await SnackbarStore.setMassage({ value: "Sign Up Successfully" });
        setIsLoading(false);
        navigate("/");
      } else {
        setIsLoading(false);
      }
    }
  };

  return (
    <Grid
      container
      component="main"
      className="sing-up"
      sx={{ p: isNonMobile ? "50px" : "10px" }}
    >
      <Container component="main" maxWidth="xs">
        <Box component="div" className="container">
          <Box component="div" className="brand-name-logo-container">
            <Link to={"/"} component="div" className="brand-name-logo">
              <img src={BRAND_NAME_LOGO} alt="brand-logo" />
            </Link>
          </Box>

          <Typography component="h1" variant="h5" className="title">
            Verify OTP
          </Typography>
          <Stack spacing={2} sx={{ mt: 3 }}>
            <p style={{ textAlign: "center" }}>
              Enter the code we just send on your email{" "}
              {AuthStore.signInForm.email.substring(0, 4)}
              ****@gmail.com OTP
            </p>
            <TextField
              name="OTP"
              inputProps={{
                inputMode: "numeric",
                maxLength: 4,
                style: { textAlign: "center" },
              }}
              required
              fullWidth
              label="OTP"
              value={inputOTP}
              onChange={(e) => setInputOTP(e.target.value)}
            />
            <div className="btn">
              <LoadingButton
                loading={isLoading}
                variant="contained"
                fullWidth
                style={{ background: !isLoading && "#000" }}
                onClick={verifyOTP}
              >
                <p>Verify</p>
              </LoadingButton>
            </div>
          </Stack>
        </Box>
      </Container>
    </Grid>
  );
};

export default Verification;
